import * as configuration from "../config/app-config.js";

export const getResourceThumbnail = (assetName) => {
  if (assetName) {
    const fileType = assetName
      .toLowerCase()
      .split(".")
      .splice(-1, 1)
      ?.toString();

    console.log("fileType::", fileType, `${configuration.API_URL}auth/assets/${assetName}`);
    if (fileType === "png" || fileType === "jpg" || fileType === "jpeg") {
      return (
        <img
          width="40"
          height="40"
          src={`${configuration.API_URL}auth/assets/${assetName}`}
          alt={fileType}
        />
      );
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const handleonlyNumber = (event) => {

  const validChars = /[0-9+\-\(\)\s]/;
    // const maxLength = 15; 

    if (!validChars.test(event.key) && event.key !== "Backspace" && event.key !== "Delete") {
      event.preventDefault();
    }

    // if (value.length >= maxLength && event.key !== "Backspace" && event.key !== "Delete") {
    //   event.preventDefault();
    // }
};

export const handleage = (event) => {
  console.log("age" , event)

  const validChars = /[0-9]/;
    // const maxLength = 15; 

    if (!validChars.test(event.key) && event.key !== "Backspace" && event.key !== "Delete") {
      event.preventDefault();
    }

};


export const chipColor = (status) => {
  switch (status) {
    case "A":
      return "chip-Approved";
    case "R":
      return "chip-Requested";
    default:
      return "chip-Default";
  }
}

export const preventDefaultEnter = (e) =>{
  if (e.key === "Enter") {
    e.preventDefault(); 
  }
}

export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// export const getImageAssetspath = (assetName) => {
//   if (assetName) {
//     const fileType = assetName
//       .toLowerCase()
//       .split(".")
//       .splice(-1, 1)
//       ?.toString();

//     console.log("fileType::", fileType, `${configuration.API_URL}auth/assets/${assetName}`);
//     if (fileType === "png" || fileType === "jpg" || fileType === "jpeg") {
//       return (
//         <img
//           width="40"
//           height="40"
//           src={`${configuration.API_URL}auth/assets/${assetName}`}
//           alt={fileType}
//         />
//       );
//     } else {
//       return "";
//     }
//   } else {
//     return "";
//   }
// };

